import React, { useState, useEffect, useRef, useCallback } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import c from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWindowWidth } from "@react-hook/window-size";
import animateScrollTo from "animated-scroll-to";
import Skeleton from "react-loading-skeleton";

import { usePost, useSitemap, getFeaturedMedia } from "../providers/content";
import { getLocation } from "../util/url";
import { ImageBlock, ContentBlock, WindowBlock, DateBlock, WidgetBlock } from "../blocks";

import theme from "../theme.js";

export const Single404 = () => {
  return (
    <>
      <ContentBlock>
        <h1>404</h1>
        <div className="pt-3">
          <span>Es konnten keine Ergebnisse für die angefragte Seite gefunden werden.</span>
        </div>
      </ContentBlock>
    </>
  );
};

// const Breadcrumb = ({ post }) => {
//   const sitemap = useSitemap();

//   const evaluateSitemapItem = (prevItems, postId, { id, children, title, href }) => {
//     let self = (
//       <li className="breadcrumb-item">
//         <a href={getLocation(href)}>
//           <span dangerouslySetInnerHTML={{ __html: title }} />
//         </a>
//       </li>
//     );

//     const itemStack = prevItems.concat([self]);

//     if (postId === id) {
//       return (
//         <ol className="breadcrumb bg-white p-0">
//           <li className="breadcrumb-item">
//             <a href="/">
//               <FontAwesomeIcon icon="home" size="sm" />
//             </a>
//           </li>
//           {itemStack}
//         </ol>
//       );
//     } else {
//       if (children && children.length > 0) {
//         return <>{children.map((child) => evaluateSitemapItem(itemStack, postId, child))}</>;
//       }
//     }

//     return null;
//   };

//   return post && sitemap ? (
//     <nav className="pb-3">{sitemap.map((entry) => evaluateSitemapItem([], post.id, entry))}</nav>
//   ) : (
//     <Skeleton width={500} />
//   );
// };

export const Single = (props) => {
  const [post, unlock] = usePost(props);
  const width = useWindowWidth();

  const featuredMedia = getFeaturedMedia();

  useEffect(() => {
    const scrollTargetId = window.location.hash.substring(1);
    const scrollTargetElement = document.getElementById(scrollTargetId);

    if (scrollTargetElement) {
      animateScrollTo(scrollTargetElement, {
        verticalOffset: -200,
      });
    }
  }, []);

  const reducedContainerSize =
    post && post.template === "single-reduced-container-size.php" && width >= parseInt(theme["mebm-breakpoint-lg"]);

  return (
    <div style={{ width: reducedContainerSize ? "calc(100% - 300px)" : "100%" }} className="mx-auto w-sm-100" id="single-featured-image">
      {featuredMedia.src && (
        <WindowBlock>
          <ImageBlock src={featuredMedia.src} style={{ height: "350px" }} width={featuredMedia.width} height={featuredMedia.height} imgProps={{"aria-hidden": true}}/>
        </WindowBlock>
      )}
    </div>
  );
};
